import React from 'react';
import { render } from 'react-dom';
import { hot } from 'react-hot-loader/root';
// react-router-dom v6: `Switch` no longer exists (it was v5). This file had been importing it
// against v6.30.1, so `Switch` was `undefined` — webpack only WARNED on the missing export, so
// it shipped; rspack treats it as a linking error, which is how it surfaced. See the note by
// <Routes> below: this page has been broken under v6, not merely unmigrated.
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { ThemeProvider } from '@workboard/wobo-ui';
import Sidebar from './components/Sidebar';
import EngagementReportTeams from './screens/teams';
import EngagementReportOKRs from './screens/okrs';

const Styles = createGlobalStyle`
  .contentTd2, #content {
    background-color: #f1f3f5;
  }

  .contentTd2 .contentContainer {
    padding: 0;
  }

  body .ui-tooltip {
    display: none !important;
  }

  // Workaround for css in wb/wobo-frontend/src/apps/meetings/screens/details.scss
  .MuiBackdrop-root {
    background-color: rgba(0,0,0,0.14) !important;
  }

  div#footer {
    position: fixed;
    left: 50vw;
    margin: 0px;
    bottom: 10px;
  }
`;

const App = hot(props => {
  return (
    <ThemeProvider>
      <Styles />
      <Router basename='/wb/engagementReport'>
        <Sidebar {...props} />
        {/*
          v5 → v6: <Switch> becomes <Routes>, and route children become `element`.
          v5's `path='/'` (no `exact`) matched every path, so its v6 equivalent is `path='/*'`
          — plain `path='/'` in v6 would match ONLY the index and silently render nothing
          for any sub-path. ⚠️ UNVERIFIED AT RUNTIME: this page renders only when the PHP
          page calls window.initEngagementReport, which we cannot exercise from a build.
        */}
        <Routes>
          <Route path='/okrs' element={<EngagementReportOKRs />} />
          <Route path='/*' element={<EngagementReportTeams />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
});

window.initEngagementReport = props => {
  render(<App {...props} />, document.getElementById('engagement-report-app'));
};
